export const initialState = {
  actionProcessing: false,
  transactions: [],
  activeRequests: {},
  withdrawalHistory: {},
};
